import { makeStyles } from "@saleor/macaw-ui";

const useStyles = makeStyles(
  theme => ({
    root: {},
    piNo: {
      margin: "25px 0",
      display: "flex",
      alignItems: "center",
      "& img": {
        marginRight: 10
      }
    },
    itemPiNo: {
      marginRight: 10
    },
    mainContent: {
      background: "#FFF",
      boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.12)",
      borderRadius: 12,
      padding: "2.4rem"
    },
    titleField: {
      marginBottom: 5
    },
    soldToInfo: {
      background: "#F2FAFB",
      borderRadius: 4,
      padding: "1.2rem"
    },
    textCode: {
      color: theme.palette.info.dark,
      marginBottom: 5,
      fontSize: "1.8rem"
    },
    textAddress: {
      color: theme.palette.grey[800],
      marginBottom: 5
    },
    selectField: {
      "& .MuiFormControl-root": {
        height: 37
      }
    },
    pickAddress: {
      display: "flex"
    },
    addressContent: {
      maxWidth: "90%"
    },
    btnEdit: {
      marginLeft: "auto",
      height: 32
    },
    titleArea: {
      display: "flex",
      alignItems: "center",
      fontSize: "1.2rem",
      lineHeight: "18px",
      "& img": {
        marginRight: 10
      }
    },
    textError: {
      color: theme.palette.error.light,
      marginTop: 5
    },
    lineMultiText: {
      whiteSpace: "pre-line"
    },
    applyBtn: {
      width: "100%",
      padding: "0.6rem",
      fontSize: "14px",
      color: "white",
      backgroundColor: "#222",
      "& .MuiButton-label": {
        fontWeight: "700"
      }
    }
  }),
  { name: "OrderHeaderTab" }
);

export default useStyles;
